module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M21 8h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1v6a1 1 0 0 0 1 1zm6 2h-8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V11a1 1 0 0 0-1-1zM8.61 18H12v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h3.39c.594 0 .788.528.43 1l-5.174 6.652c-.358.468-.936.462-1.292-.008L8.18 19c-.358-.47-.164-1 .43-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/download-document-1.js
// module id = 1120
// module chunks = 14